import { useRef, useCallback } from 'react';

/**
 * Custom hook to manage an array of refs.
 * Returns a ref setter function and the array of refs.
 */
export function useRefArray<T>() {
  const refs = useRef<Array<T | null>>([]);

  const setRef = useCallback((index: number) => (el: T | null) => {
    refs.current[index] = el;
  }, []);

  return [setRef, refs.current] as const;
}